import styled from 'styled-components/macro';

const Handle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 24px;

  path {
    opacity: 0.4;
    transition: opacity 0.15s ease-out;
  }

  &:hover path {
    opacity: 1;
  }
`;

export default Handle;
